module.exports = __webpack_public_path__ + "static/img/menage12.5317d599.jpg";